import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { pathgen } from 'object-path-generator';
import { Button, MenuItem, MenuPromotionalAction, SplitButton } from 'seagull';
import { useEventReporter } from '~/event-reporter';
import { useRedirectToProposal } from '~/hooks/useCreateAgreement';
import { useOpenNewProposal } from '~/hooks/useOpenNewProposal';
import { useLocaleKeys } from '~/i18n';
import styles from './CreateProposalButton.module.scss';
const createProposalButtonPaths = pathgen('CreateProposalButtonTestIds');
export const CreateProposalButtonTestIds = {
    SplitButton: {
        Root: createProposalButtonPaths.SplitButton.Root,
        Main: ()=>"".concat(createProposalButtonPaths.SplitButton.Root(), "-main"),
        Arrow: ()=>"".concat(createProposalButtonPaths.SplitButton.Root(), "-arrow"),
        NewTemplateOption: createProposalButtonPaths.SplitButton.NewTemplateOption,
        NewProposalOption: createProposalButtonPaths.SplitButton.NewProposalOption,
        ImportAgreementOption: createProposalButtonPaths.SplitButton.ImportAgreementOption
    },
    Button: createProposalButtonPaths.Button
};
export const CreateProposalButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { t: cpTexts } = useLocaleKeys('components.createProposalButton');
    const { text = cpTexts.defaultText(), hideTemplatePicker = false, navigationState } = props;
    const { reportButtonClick } = useEventReporter();
    const { openCreationModal } = useRedirectToProposal();
    const { isLoadingProposalTemplates, openNewProposal: _openNewProposal, openSelectProposalTypeModal, openImportAgreement } = useOpenNewProposal({
        navigationState
    });
    const { t } = useLocaleKeys();
    function openNewProposal() {
        reportButtonClick('topbar-new-agreement-btn');
        _openNewProposal();
    }
    const openNewProposalFromDraft = async ()=>{
        reportButtonClick('topbar-new-agreement-btn');
        await openCreationModal({
            state: navigationState
        });
    };
    const onNewTemplate = async ()=>{
        openSelectProposalTypeModal('template');
    };
    return !hideTemplatePicker ? /*#__PURE__*/ _jsx(SplitButton, {
        label: text,
        testId: CreateProposalButtonTestIds.SplitButton.Root(),
        onClick: openNewProposal,
        popperClassName: styles.popper,
        flushBottom: true,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(MenuItem, {
                    onClick: onNewTemplate,
                    testId: CreateProposalButtonTestIds.SplitButton.NewTemplateOption(),
                    children: cpTexts.useTemplate()
                }),
                /*#__PURE__*/ _jsx(MenuItem, {
                    onClick: openNewProposalFromDraft,
                    testId: CreateProposalButtonTestIds.SplitButton.NewProposalOption(),
                    children: cpTexts.startFromScratch()
                }),
                /*#__PURE__*/ _jsx(MenuPromotionalAction, {
                    title: t.agreementImport.menuItem.title(),
                    body: t.agreementImport.menuItem.body(),
                    testId: CreateProposalButtonTestIds.SplitButton.ImportAgreementOption(),
                    bi: {
                        name: 'import_agreement'
                    },
                    onClick: openImportAgreement
                })
            ]
        })
    }) : /*#__PURE__*/ _jsx(Button, {
        bi: {
            name: 'create_proposal'
        },
        testId: CreateProposalButtonTestIds.Button(),
        onClick: openNewProposalFromDraft,
        ref: ref,
        loading: isLoadingProposalTemplates,
        children: text
    });
});
